(function() {
  'use strict';

  var stage = document.querySelector('[data-printfall]');
  if (!stage) return;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reducedMotion.matches || !window.requestAnimationFrame) {
    stage.classList.remove('is-armed');
    return;
  }

  var phone = stage.querySelector('.fp-printfall__phone');
  var screenImg = stage.querySelector('.fp-printfall__screen-img');
  var flash = stage.querySelector('.fp-printfall__flash');
  var statusEl = stage.querySelector('.fp-printfall__status');
  var replay = stage.querySelector('.fp-printfall__replay');
  var printEls = Array.prototype.slice.call(stage.querySelectorAll('.fp-drop'));
  var PRINT_FLIGHT_MS = 2500;
  var PRINT_GAP_MS = 680;
  var FIRST_PRINT_MS = 450;
  var LANDED_LEAVES = 10;
  var MAX_LANDED_LEAVES = 13;
  var AMBIENT_LEAF_MS = 2100;
  var LEAF_SPOTS = [
    [30, 36], [2, 44], [58, 60], [24, 86], [48, 90], [88, 92],
    [62, 34], [12, 2], [40, 64], [6, 80], [70, 58], [52, 18]
  ];
  var leafSpot = Math.floor(Math.random() * 12);
  var LEAF_COLORS = ['#c8452c', '#e0782f', '#e9a93a', '#b5562b', '#d4622d', '#a83b24', '#d99a2b'];
  var LEAF_SHAPES = [
    'M50 3 57 21 68 14 65 34 83 24 78 39 97 41 83 53 89 59 66 63 68 73 54 67 52 97 48 97 46 67 32 73 34 63 11 59 17 53 3 41 22 39 17 24 35 34 32 14 43 21Z',
    'M50 4C79 22 85 62 50 96 15 62 21 22 50 4Z',
    'M50 5C63 18 80 20 86 36 75 42 88 55 78 66 66 64 62 80 50 95 38 80 34 64 22 66 12 55 25 42 14 36 20 20 37 18 50 5Z'
  ];
  var LEAF_VEINS = [
    'M50 95V30M50 63 28 45M50 63 72 45M50 44 36 28M50 44 64 28',
    'M50 94V14M50 40 36 30M50 40 64 30M50 60 32 48M50 60 68 48',
    'M50 93V20M50 55 30 44M50 55 70 44M50 72 36 64M50 72 64 64'
  ];

  var W = 0;
  var H = 0;
  var phoneCenter = { x: 0, y: 0 };
  var screenWidth = 0;
  var prints = [];
  var leaves = [];
  var running = false;
  var interactive = false;
  var inView = true;
  var rafId = 0;
  var ambientTimer = 0;
  var timers = [];
  var pointer = { x: 0, y: 0, t: 0, inside: false };
  var hovered = null;
  var drag = null;
  var stackOrder = [];

  function lerp(a, b, t) { return a + (b - a) * t; }
  function clamp(v, min, max) { return Math.max(min, Math.min(max, v)); }
  function easeOutCubic(t) { return 1 - Math.pow(1 - t, 3); }
  function easeInOutSine(t) { return -(Math.cos(Math.PI * t) - 1) / 2; }
  function smoothstep(t) { return t * t * (3 - 2 * t); }
  function rand(min, max) { return min + Math.random() * (max - min); }

  function later(fn, ms) {
    var id = setTimeout(fn, ms);
    timers.push(id);
    return id;
  }

  function clearTimers() {
    timers.forEach(clearTimeout);
    timers = [];
  }

  function makeBody(el, kind) {
    return {
      el: el,
      kind: kind,
      baseR: 0,
      restX: 0,
      restY: 0,
      homeX: 0,
      homeY: 0,
      ox: 0, oy: 0, or: 0,
      vx: 0, vy: 0, vr: 0,
      tvx: 0, tvy: 0,
      rx: 0, ry: 0, s: 1,
      tRx: 0, tRy: 0, tS: 1,
      flut: 0,
      seed: Math.random() * 100,
      flight: null,
      lift: 0,
      clip: 0,
      opacity: 1
    };
  }

  /* ——— Layout ——— */
  function measure() {
    W = stage.clientWidth;
    H = stage.clientHeight;
    phoneCenter.x = phone.offsetLeft + phone.offsetWidth / 2;
    phoneCenter.y = phone.offsetTop + phone.offsetHeight / 2;
    screenWidth = phone.offsetWidth * 0.9;
    prints.forEach(function(p) {
      p.baseR = parseFloat(getComputedStyle(p.el).getPropertyValue('--r')) || 0;
      p.restX = p.el.offsetLeft + p.el.offsetWidth / 2;
      p.restY = p.el.offsetTop + p.el.offsetHeight / 2;
    });
    leaves.forEach(function(l) {
      l.restX = l.el.offsetLeft + l.el.offsetWidth / 2;
      l.restY = l.el.offsetTop + l.el.offsetHeight / 2;
    });
  }

  function applyStack() {
    stackOrder.forEach(function(p, i) { p.el.style.zIndex = String(6 + i); });
    if (hovered) hovered.el.style.zIndex = '13';
  }

  /* ——— Rendering ——— */
  function render(b) {
    var x = b.homeX + b.ox;
    var y = b.homeY + b.oy;
    var r = b.baseR + b.or;
    var rx = b.rx + Math.sin(performance.now() / 85 + b.seed) * b.flut * 16;
    var ry = b.ry + Math.cos(performance.now() / 110 + b.seed) * b.flut * 10;
    b.el.style.transform =
      'translate3d(' + x.toFixed(2) + 'px,' + y.toFixed(2) + 'px,0) rotate(' + r.toFixed(2) +
      'deg) rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg) scale(' + b.s.toFixed(4) + ')';

    if (b.kind === 'print') {
      var lift = Math.max(b.lift, (b.s - 1) * 8);
      b.el.style.boxShadow =
        '0 ' + (18 + 44 * lift).toFixed(1) + 'px ' + (40 + 46 * lift).toFixed(1) + 'px rgba(62,46,35,' + (0.18 - 0.05 * lift).toFixed(3) + '),' +
        '0 3px 8px rgba(62,46,35,' + (0.1 * (1 - Math.min(1, lift))).toFixed(3) + ')';
      b.el.style.clipPath = b.clip > 0.1 ? 'inset(' + b.clip.toFixed(1) + 'px round 2px)' : '';
      b.el.style.opacity = b.opacity.toFixed(3);
    } else {
      b.el.style.opacity = b.opacity.toFixed(3);
    }
  }

  /* ——— Flights ——— */
  function printFlight(p, index) {
    var pad = parseFloat(getComputedStyle(p.el).paddingLeft) || 8;
    var p0x = phoneCenter.x - p.restX;
    var p0y = phoneCenter.y - p.restY;
    var p1x = p0x - W * rand(0.14, 0.2);
    var p1y = p0y - H * rand(0.12, 0.17);
    var s0 = screenWidth / p.el.offsetWidth;
    var phase = index * 1.35 + rand(0, 0.6);
    var swings = rand(2.6, 3.2);

    p.homeX = 0;
    p.homeY = 0;
    p.ox = p.oy = p.or = 0;
    p.vx = p.vy = p.vr = 0;

    return {
      start: performance.now(),
      dur: PRINT_FLIGHT_MS,
      step: function(t) {
        if (t < 0.2) {
          var u = easeOutCubic(t / 0.2);
          p.ox = lerp(p0x, p1x, u);
          p.oy = lerp(p0y, p1y, u);
          p.s = lerp(s0, 0.92, u);
          p.or = lerp(7, -10, u) - p.baseR;
          p.rx = lerp(0, -28, u);
          p.ry = 0;
          p.clip = pad * (1 - u);
          p.lift = 1;
          p.opacity = Math.min(1, t / 0.05);
          return;
        }
        var v = (t - 0.2) / 0.8;
        var e = easeInOutSine(v);
        var damp = Math.pow(1 - v, 1.25);
        var wave = v * Math.PI * swings + phase;
        var sw = Math.sin(wave);
        p.ox = lerp(p1x, 0, e) + sw * W * 0.075 * damp;
        p.oy = lerp(p1y, 0, smoothstep(v)) - Math.abs(Math.cos(wave)) * H * 0.03 * damp;
        p.or = lerp(-10, p.baseR, e) + sw * 26 * damp - p.baseR;
        p.rx = lerp(-28, 0, v) * (1 - v) + Math.cos(wave) * 38 * damp;
        p.ry = sw * 20 * damp;
        p.s = lerp(0.92, 1, e);
        p.clip = 0;
        p.lift = damp;
        p.opacity = 1;
      },
      done: function() {
        p.ox = p.oy = p.or = 0;
        p.rx = p.ry = 0;
        p.s = 1;
        p.lift = 0;
        p.clip = 0;
        p.vy = -2.2;
        p.vr = rand(-1.2, 1.2);
        p.flut = 0.35;
      }
    };
  }

  function returnFlight(p, onDone) {
    var fromX = p.homeX + p.ox;
    var fromY = p.homeY + p.oy;
    var fromR = p.or;
    var toX = phoneCenter.x - p.restX;
    var toY = phoneCenter.y - p.restY;
    var s0 = screenWidth / p.el.offsetWidth;
    p.homeX = p.homeY = 0;
    return {
      start: performance.now(),
      dur: 520,
      step: function(t) {
        var u = easeInOutSine(t);
        p.ox = lerp(fromX, toX, u);
        p.oy = lerp(fromY, toY, u) - Math.sin(u * Math.PI) * H * 0.12;
        p.or = lerp(fromR, 7 - p.baseR, u);
        p.s = lerp(1, s0, u);
        p.rx = Math.sin(u * Math.PI) * -24;
        p.lift = Math.sin(u * Math.PI);
        p.opacity = t > 0.8 ? (1 - t) / 0.2 : 1;
      },
      done: function() {
        p.el.classList.add('is-waiting');
        p.opacity = 0;
        if (onDone) onDone();
      }
    };
  }

  function leafFlight(l, ambient) {
    var startX = rand(0.12, 0.85) * W - l.restX;
    var startY = -H * rand(0.18, 0.32) - l.restY;
    var endX = ambient ? clamp(startX + l.restX + rand(-0.1, 0.18) * W, W * 0.12, W * 0.88) - l.restX : 0;
    var endY = ambient ? H * 1.08 - l.restY : 0;
    var spin = rand(0.6, 1.4) * (Math.random() < 0.5 ? -1 : 1);
    var phase = rand(0, Math.PI * 2);
    var swings = rand(2.4, 3.6);
    return {
      start: performance.now(),
      dur: ambient ? rand(5200, 7200) : rand(3000, 4400),
      step: function(t) {
        var damp = ambient ? 1 : Math.pow(1 - t, 1.1);
        var wave = t * Math.PI * swings + phase;
        var sw = Math.sin(wave);
        l.ox = lerp(startX, endX, easeInOutSine(t)) + sw * W * (ambient ? 0.05 : 0.08) * damp;
        l.oy = lerp(startY, endY, ambient ? t : smoothstep(t)) - Math.abs(Math.cos(wave)) * H * 0.025 * damp;
        l.or = (1 - t) * spin * 260 + sw * 40 * damp + (ambient ? spin * 200 * t : 0);
        l.rx = Math.cos(wave) * 60 * damp;
        l.ry = sw * 55 * damp;
        l.opacity = ambient ? Math.min(1, t / 0.08) * (t > 0.85 ? (1 - t) / 0.15 : 1) : Math.min(1, t / 0.06);
      },
      done: function() {
        if (ambient) {
          removeLeaf(l);
          return;
        }
        l.ox = l.oy = l.or = 0;
        l.rx = l.ry = 0;
        l.flut = 0.2;
      }
    };
  }

  /* ——— Leaves ——— */
  function createLeafEl(front) {
    var shape = Math.floor(Math.random() * LEAF_SHAPES.length);
    var color = LEAF_COLORS[Math.floor(Math.random() * LEAF_COLORS.length)];
    var el = document.createElement('span');
    el.className = 'fp-leaf' + (front ? ' fp-leaf--front' : '');
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML =
      '<svg viewBox="0 0 100 100" focusable="false"><path d="' + LEAF_SHAPES[shape] + '" fill="' + color + '"/>' +
      '<path d="' + LEAF_VEINS[shape] + '" fill="none" stroke="rgba(70,30,10,.35)" stroke-width="2.2" stroke-linecap="round"/></svg>';
    el.style.setProperty('--leaf-size', rand(5.5, 9).toFixed(2) + '%');
    return el;
  }

  function addLeaf(ambient) {
    var el = createLeafEl(ambient || Math.random() < 0.7);
    if (ambient) {
      el.style.left = rand(5, 90).toFixed(1) + '%';
      el.style.top = '0%';
    } else {
      var spot = LEAF_SPOTS[leafSpot++ % LEAF_SPOTS.length];
      el.style.left = clamp(spot[0] + rand(-4, 4), 3, 90).toFixed(1) + '%';
      el.style.top = (spot[1] + rand(-4, 4)).toFixed(1) + '%';
    }
    stage.appendChild(el);
    var l = makeBody(el, 'leaf');
    l.baseR = rand(-160, 160);
    l.restX = el.offsetLeft + el.offsetWidth / 2;
    l.restY = el.offsetTop + el.offsetHeight / 2;
    l.opacity = 0;
    l.ambient = ambient;
    l.flight = leafFlight(l, ambient);
    leaves.push(l);

    if (!ambient) {
      var landed = leaves.filter(function(x) { return !x.ambient; });
      if (landed.length > MAX_LANDED_LEAVES) removeLeaf(landed[0]);
    }
    wake();
  }

  function removeLeaf(l) {
    var i = leaves.indexOf(l);
    if (i !== -1) leaves.splice(i, 1);
    if (l.el.parentNode) l.el.parentNode.removeChild(l.el);
  }

  function scheduleAmbient() {
    clearTimeout(ambientTimer);
    ambientTimer = setTimeout(function() {
      if (inView && !document.hidden) {
        var falling = leaves.filter(function(x) { return x.ambient; }).length;
        if (falling < 3) addLeaf(true);
      }
      scheduleAmbient();
    }, AMBIENT_LEAF_MS + rand(-600, 900));
  }

  /* ——— Phone ——— */
  function showOnScreen(p) {
    var img = p.el.querySelector('img');
    var src = img && (img.currentSrc || img.src);
    if (src) screenImg.src = src;
  }

  function pulsePhone() {
    phone.classList.remove('is-ejecting');
    flash.classList.remove('is-on');
    void phone.offsetWidth;
    phone.classList.add('is-ejecting');
    flash.classList.add('is-on');
  }

  /* ——— Sequence ——— */
  function launch(p, index) {
    showOnScreen(p);
    statusEl.textContent = 'Printing ' + (index + 1) + ' of ' + prints.length;
    later(function() {
      pulsePhone();
      p.el.classList.remove('is-waiting');
      p.flight = printFlight(p, index);
      wake();
      var nextPrint = prints[index + 1];
      if (nextPrint) later(function() { showOnScreen(nextPrint); }, 380);
    }, 260);
  }

  var AUTO_REPLAY_MS = 30000;
  var AUTO_REPLAY_RETRY_MS = 3000;
  var autoReplayTimer = 0;

  function scheduleAutoReplay(ms) {
    clearTimeout(autoReplayTimer);
    autoReplayTimer = setTimeout(function() {
      if (!interactive) return;
      if (!inView || document.hidden || drag || pointer.inside) {
        scheduleAutoReplay(AUTO_REPLAY_RETRY_MS);
        return;
      }
      replaySequence();
    }, ms);
  }

  function playSequence(withLeaves) {
    interactive = false;
    stage.classList.remove('is-interactive');
    replay.hidden = true;
    replay.classList.remove('is-shown');

    prints.forEach(function(p) {
      p.el.classList.add('is-waiting');
      p.opacity = 0;
      p.homeX = p.homeY = 0;
      p.tvx = p.tvy = 0;
    });
    stackOrder = prints.slice();
    applyStack();

    prints.forEach(function(p, i) {
      later(function() { launch(p, i); }, FIRST_PRINT_MS + i * PRINT_GAP_MS);
    });

    var leafCount = withLeaves ? LANDED_LEAVES : 3;
    for (var i = 0; i < leafCount; i++) {
      later(function() { addLeaf(false); }, 250 + i * rand(380, 520));
    }

    var finish = FIRST_PRINT_MS + (prints.length - 1) * PRINT_GAP_MS + 260 + PRINT_FLIGHT_MS + 150;
    later(function() {
      statusEl.textContent = prints.length + ' real prints ✓';
      interactive = true;
      stage.classList.add('is-interactive');
      replay.hidden = false;
      replay.classList.add('is-shown');
      scheduleAutoReplay(AUTO_REPLAY_MS);
    }, finish);
  }

  function replaySequence() {
    clearTimeout(autoReplayTimer);
    clearTimers();
    interactive = false;
    stage.classList.remove('is-interactive');
    replay.hidden = true;
    statusEl.textContent = 'Back to your camera roll…';
    var returned = 0;
    prints.slice().reverse().forEach(function(p, i) {
      later(function() {
        p.flight = returnFlight(p, function() {
          returned++;
          if (returned === prints.length) later(function() { playSequence(false); }, 250);
        });
        wake();
      }, i * 90);
    });
  }

  function keepInside(b, bounce) {
    var halfW = b.el.offsetWidth * 0.5;
    var halfH = b.el.offsetHeight * 0.5;
    var minX = halfW;
    var maxX = Math.max(minX, W - halfW);
    var minY = halfH;
    var maxY = Math.max(minY, H - halfH);
    var cx = b.restX + b.homeX;
    var cy = b.restY + b.homeY;
    if (bounce && (cx < minX || cx > maxX)) b.tvx *= -0.45;
    if (bounce && (cy < minY || cy > maxY)) b.tvy *= -0.45;
    b.homeX = clamp(cx, minX, maxX) - b.restX;
    b.homeY = clamp(cy, minY, maxY) - b.restY;
  }

  /* ——— Physics loop ——— */
  function stepBody(b, now) {
    if (b.flight) {
      var t = clamp((now - b.flight.start) / b.flight.dur, 0, 1);
      b.flight.step(t);
      if (t >= 1) {
        var f = b.flight;
        b.flight = null;
        f.done();
      }
      return true;
    }
    if (b === (drag && drag.body)) {
      b.ox += (0 - b.ox) * 0.35;
      b.oy += (0 - b.oy) * 0.35;
      b.vr *= 0.8;
      b.or += b.vr;
      b.or *= 0.9;
    } else {
      if (Math.abs(b.tvx) + Math.abs(b.tvy) > 0.05) {
        b.homeX += b.tvx;
        b.homeY += b.tvy;
        b.tvx *= 0.9;
        b.tvy *= 0.9;
        keepInside(b, true);
      }
      b.vx += -b.ox * 0.07; b.vx *= 0.84; b.ox += b.vx;
      b.vy += -b.oy * 0.07; b.vy *= 0.84; b.oy += b.vy;
      b.vr += -b.or * 0.06; b.vr *= 0.85; b.or += b.vr;
    }
    b.rx += (b.tRx - b.rx) * 0.16;
    b.ry += (b.tRy - b.ry) * 0.16;
    b.s += (b.tS - b.s) * 0.16;
    b.flut *= 0.955;

    var energy = Math.abs(b.ox) + Math.abs(b.oy) + Math.abs(b.or) + Math.abs(b.vx) + Math.abs(b.vy) +
      Math.abs(b.vr) + Math.abs(b.tvx) + Math.abs(b.tvy) + Math.abs(b.rx - b.tRx) + Math.abs(b.ry - b.tRy) +
      Math.abs(b.s - b.tS) * 50 + b.flut * 10;
    return energy > 0.02;
  }

  function frame(now) {
    rafId = 0;
    var active = false;
    prints.forEach(function(p) {
      if (stepBody(p, now)) active = true;
      render(p);
    });
    leaves.slice().forEach(function(l) {
      if (stepBody(l, now)) active = true;
      if (l.el.parentNode) render(l);
    });
    if ((active || drag) && inView && !document.hidden) rafId = requestAnimationFrame(frame);
  }

  function wake() {
    if (!rafId && inView && !document.hidden) rafId = requestAnimationFrame(frame);
  }

  /* ——— Interaction ——— */
  function localPoint(event) {
    var box = stage.getBoundingClientRect();
    var sx = box.width ? W / box.width : 1;
    var sy = box.height ? H / box.height : 1;
    return { x: (event.clientX - box.left) * sx, y: (event.clientY - box.top) * sy };
  }

  function bodyFor(el) {
    for (var i = 0; i < prints.length; i++) if (prints[i].el === el) return prints[i];
    return null;
  }

  function setHovered(p, event) {
    if (hovered && hovered !== p) {
      hovered.tRx = hovered.tRy = 0;
      hovered.tS = 1;
      hovered.el.style.setProperty('--sheen', '.12');
    }
    hovered = p;
    if (p) {
      var box = p.el.getBoundingClientRect();
      var lx = clamp((event.clientX - box.left) / box.width, 0, 1);
      var ly = clamp((event.clientY - box.top) / box.height, 0, 1);
      p.tRx = (0.5 - ly) * 22;
      p.tRy = (lx - 0.5) * 22;
      p.tS = drag && drag.body === p ? 1.09 : 1.06;
      p.el.style.setProperty('--mx', (lx * 100).toFixed(1) + '%');
      p.el.style.setProperty('--my', (ly * 100).toFixed(1) + '%');
      p.el.style.setProperty('--sheen', '.42');
    }
    applyStack();
  }

  function breeze(pt, dx, dy) {
    var speed = Math.sqrt(dx * dx + dy * dy);
    if (speed < 1.5) return;
    var radius = Math.max(140, W * 0.22);
    var all = prints.concat(leaves);
    for (var i = 0; i < all.length; i++) {
      var b = all[i];
      if (b.flight || (drag && drag.body === b) || b.ambient) continue;
      var cx = b.restX + b.homeX + b.ox;
      var cy = b.restY + b.homeY + b.oy;
      var dist = Math.sqrt((cx - pt.x) * (cx - pt.x) + (cy - pt.y) * (cy - pt.y));
      if (dist > radius) continue;
      var f = Math.pow(1 - dist / radius, 2);
      var k = b.kind === 'leaf' ? 0.55 : (b === hovered ? 0.03 : 0.12);
      b.vx += clamp(dx, -40, 40) * f * k;
      b.vy += clamp(dy, -40, 40) * f * k * 0.7;
      b.vr += clamp(dx, -40, 40) * f * k * (b.kind === 'leaf' ? 1.6 : 0.5);
      b.flut = Math.min(b.kind === 'leaf' ? 1.4 : 0.7, b.flut + speed * f * 0.02);
    }
    wake();
  }

  stage.addEventListener('pointermove', function(event) {
    if (event.pointerType === 'touch') return;
    var pt = localPoint(event);
    var dx = pointer.inside ? pt.x - pointer.x : 0;
    var dy = pointer.inside ? pt.y - pointer.y : 0;
    pointer.x = pt.x;
    pointer.y = pt.y;
    pointer.inside = true;

    if (drag) {
      drag.body.homeX = drag.homeX + (pt.x - drag.startX);
      drag.body.homeY = drag.homeY + (pt.y - drag.startY);
      keepInside(drag.body, false);
      drag.body.vr += dx * 0.12;
      drag.samples.push({ x: pt.x, y: pt.y, t: performance.now() });
      if (drag.samples.length > 5) drag.samples.shift();
      setHovered(drag.body, event);
      breeze(pt, dx * 0.6, dy * 0.6);
      wake();
      return;
    }

    if (!interactive) return;
    breeze(pt, dx, dy);
    var target = event.target.closest && event.target.closest('.fp-drop');
    setHovered(target ? bodyFor(target) : null, event);
    wake();
  });

  stage.addEventListener('pointerleave', function() {
    pointer.inside = false;
    if (!drag) setHovered(null);
    wake();
  });

  stage.addEventListener('pointerdown', function(event) {
    if (!interactive) return;
    var target = event.target.closest && event.target.closest('.fp-drop');
    var p = target && bodyFor(target);
    if (!p || p.flight) return;

    if (event.pointerType === 'touch') {
      p.vr += rand(-7, 7);
      p.vy -= 5;
      p.flut = 0.9;
      wake();
      return;
    }

    event.preventDefault();
    var pt = localPoint(event);
    drag = {
      body: p,
      startX: pt.x,
      startY: pt.y,
      homeX: p.homeX,
      homeY: p.homeY,
      samples: [{ x: pt.x, y: pt.y, t: performance.now() }]
    };
    p.tvx = p.tvy = 0;
    p.el.classList.add('is-dragging');
    try { p.el.setPointerCapture(event.pointerId); } catch (e) {}
    stackOrder.splice(stackOrder.indexOf(p), 1);
    stackOrder.push(p);
    setHovered(p, event);
    wake();
  });

  function endDrag(event) {
    if (!drag) return;
    var p = drag.body;
    var s = drag.samples;
    if (s.length > 1) {
      var a = s[0];
      var b = s[s.length - 1];
      var dt = Math.max(16, b.t - a.t);
      p.tvx = clamp((b.x - a.x) / dt * 16, -45, 45);
      p.tvy = clamp((b.y - a.y) / dt * 16, -45, 45);
      p.vr += p.tvx * 0.5;
      p.flut = Math.min(1, (Math.abs(p.tvx) + Math.abs(p.tvy)) * 0.03);
    }
    p.el.classList.remove('is-dragging');
    if (p.el.releasePointerCapture && event && event.pointerId !== undefined) {
      try { p.el.releasePointerCapture(event.pointerId); } catch (e) {}
    }
    drag = null;
    if (!pointer.inside) setHovered(null);
    else p.tS = 1.06;
    wake();
  }

  stage.addEventListener('pointerup', endDrag);
  stage.addEventListener('pointercancel', endDrag);
  stage.addEventListener('lostpointercapture', function(event) { if (drag) endDrag(event); });
  stage.addEventListener('dragstart', function(event) { event.preventDefault(); });

  replay.addEventListener('click', replaySequence);

  /* ——— Lifecycle ——— */
  var imagesReady = false;
  var seenEnough = false;
  var played = false;

  function maybeStart() {
    if (played || !imagesReady || !seenEnough) return;
    played = true;
    measure();
    playSequence(true);
    scheduleAmbient();
  }

  var visibilityObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      inView = entry.isIntersecting;
      if (entry.intersectionRatio >= 0.4) {
        seenEnough = true;
        maybeStart();
      }
      if (inView) wake();
    });
  }, { threshold: [0, 0.05, 0.4] });

  document.addEventListener('visibilitychange', function() {
    if (!document.hidden) wake();
  });

  var resizeTimer = 0;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      measure();
      wake();
    }, 120);
  });

  reducedMotion.addEventListener && reducedMotion.addEventListener('change', function() {
    if (!reducedMotion.matches) return;
    clearTimeout(autoReplayTimer);
    clearTimers();
    clearTimeout(ambientTimer);
    leaves.slice().forEach(removeLeaf);
    prints.forEach(function(p) {
      p.flight = null;
      p.el.classList.remove('is-waiting');
      p.el.removeAttribute('style');
    });
    stage.classList.remove('is-armed', 'is-running', 'is-interactive');
    replay.hidden = true;
  });

  function waitForImages(maxMs) {
    var imgs = printEls.map(function(el) { return el.querySelector('img'); }).filter(Boolean);
    var decodes = imgs.map(function(img) {
      if (img.decode) return img.decode().catch(function() {});
      return img.complete ? Promise.resolve() : new Promise(function(r) { img.addEventListener('load', r); img.addEventListener('error', r); });
    });
    return Promise.race([
      Promise.all(decodes),
      new Promise(function(r) { setTimeout(r, maxMs); })
    ]);
  }

  function showSettled() {
    played = true;
    prints.forEach(render);
    stage.classList.add('is-running', 'is-interactive');
    stage.classList.remove('is-armed');
    interactive = true;
    statusEl.textContent = prints.length + ' real prints ✓';
    replay.hidden = false;
    visibilityObserver.observe(stage);
    scheduleAmbient();
    scheduleAutoReplay(AUTO_REPLAY_MS);
  }

  function init() {
    prints = printEls.map(function(el) { return makeBody(el, 'print'); });
    stackOrder = prints.slice();
    measure();

    // Must stay below the 4s fp-printfall-failsafe delay in the CSS: once it has revealed the pile, never hide it again.
    var armedAt = parseFloat(stage.getAttribute('data-armed-at'));
    if (!isNaN(armedAt) && performance.now() - armedAt > 3700) {
      showSettled();
      return;
    }

    prints.forEach(function(p) {
      p.el.classList.add('is-waiting');
      p.opacity = 0;
      render(p);
    });
    stage.classList.add('is-running');
    stage.classList.remove('is-armed');
    visibilityObserver.observe(stage);

    waitForImages(2500).then(function() {
      imagesReady = true;
      maybeStart();
    });
  }

  init();
})();
